"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const primary = {
  background: 'field.1',
  backgroundDisabled: 'disabled.1',
  borderRadius: 8,
  boxShadow: '',
  boxShadowActive: [0, 0, 0, 1, 'interactive.primary.hover'],
  boxShadowDisabled: '',
  boxShadowError: [0, 0, 0, 1, 'text.negative'],
  boxShadowValid: [0, 0, 0, 1, 'text.positive'],
  color: 'text.body',
  colorDisabled: 'disabled.2',
  colorPlaceholder: 'disabled.3',
  height: 40,
  marginInner: 'xsmall',
  padding: ['none', 'medium'],
  textStyle: 'heading3'
};
const secondary = {
  background: 'background.default',
  backgroundDisabled: '',
  borderRadius: '',
  boxShadow: [0, 1, 0, 0, 'field.2'],
  boxShadowActive: [0, 1, 0, 0, 'interactive.primary.hover'],
  boxShadowDisabled: [0, 1, 0, 0, 'disabled.1'],
  boxShadowError: [0, 1, 0, 0, 'text.negative'],
  boxShadowValid: [0, 1, 0, 0, 'text.positive'],
  color: 'text.body',
  colorDisabled: 'disabled.2',
  colorPlaceholder: 'text.2',
  height: 40,
  marginInner: 'xsmall',
  padding: 'none',
  textStyle: 'heading3'
};
const search = {
  background: 'background.default',
  backgroundDisabled: '',
  borderRadius: '100px',
  boxShadow: '',
  boxShadowActive: [0, 0, 0, 1, 'interactive.primary.hover'],
  boxShadowDisabled: [0, 0, 0, 1, 'disabled.1'],
  boxShadowError: [0, 0, 0, 1, 'text.negative'],
  boxShadowValid: [0, 0, 0, 1, 'text.positive'],
  color: 'text.body',
  colorDisabled: 'disabled.2',
  colorPlaceholder: 'disabled.3',
  height: 40,
  marginInner: 'xsmall',
  padding: 'small',
  textStyle: 'body'
};
const searchForm = {
  background: 'field.1',
  backgroundDisabled: '',
  borderRadius: '100px',
  boxShadow: '',
  boxShadowActive: [0, 0, 0, 1, 'interactive.primary.hover'],
  boxShadowDisabled: [0, 0, 0, 1, 'disabled.1'],
  boxShadowError: [0, 0, 0, 1, 'text.negative'],
  boxShadowValid: [0, 0, 0, 1, 'text.positive'],
  color: 'text.body',
  colorDisabled: 'disabled.2',
  colorPlaceholder: 'disabled.3',
  height: 40,
  marginInner: 'xsmall',
  padding: 'small',
  textStyle: 'body'
};
const mainSearch = {
  background: '',
  backgroundDisabled: '',
  borderRadius: '',
  boxShadow: '',
  boxShadowActive: '',
  boxShadowDisabled: [0, 0, 0, 1, 'disabled.1'],
  boxShadowError: [0, 0, 0, 1, 'text.negative'],
  boxShadowValid: [0, 0, 0, 1, 'text.positive'],
  color: 'text.body',
  colorDisabled: 'disabled.2',
  colorPlaceholder: 'text.2',
  height: 64,
  marginInner: 'xsmall',
  padding: 'small',
  textStyle: 'body'
};
const theme = {
  primary,
  secondary,
  search,
  searchForm,
  mainSearch
};
exports.theme = theme;
//# sourceMappingURL=Input.theme.js.map